/**
 * @file header.tsx
 * @description Компонент шапка приложения.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, react-redux, @consta/icons/IconSun, @consta/icons/IconQuestion]
 * @related-files [@components/icons/logout/logout.tsx, @features/auth/auth-actions.ts, @src/store/index.ts]
 */

import { IconSun } from '@consta/icons/IconSun';
import { LogoutIcon } from '@components/icons/logout';
import { IconQuestion } from '@consta/icons/IconQuestion';
import { userLogout } from '@features/auth/auth-actions';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@src/store';

export const Header = () => {
    const dispatch = useDispatch<AppDispatch>();

    const logout = () => {
        dispatch(userLogout());
    };

    return (
        <div className="flex justify-end h-[6.2984vmin] w-full border-b-1px-ccd9e0 bg-white">
            <div className="flex items-center justify-end">
                <IconSun className="mr-[1.6937vmin] cursor-pointer text-[#35617A]" size="s" />

                <IconQuestion className="mr-[1.6937vmin] cursor-pointer text-[#35617A]" size="s" />

                <svg
                    className="mr-[1.6937vmin]"
                    width="3.3873vmin"
                    height="3.3873vmin"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_246_4301)">
                        <rect x="4" y="4" width="24" height="24" fill="#004166" fillOpacity="0.2" />
                        <rect opacity="0.24" x="4" y="4" width="24" height="24" fill="url(#paint0_linear_246_4301)" />
                        <path
                            d="M16 19C18.7614 19 20.5 16.1036 20.5 13.5C20.5 10.8964 20.1667 8 16 8C11.8333 8 11.5 10.8964 11.5 13.5C11.5 16.1036 13.2386 19 16 19Z"
                            fill="#004269"
                            fillOpacity="0.28"
                        />
                        <path
                            d="M15 21C9.5 21 7 23.0532 7 29L25 29C25 22.3333 21.5 21 17 21H15Z"
                            fill="#004269"
                            fillOpacity="0.28"
                        />
                    </g>

                    <defs>
                        <linearGradient
                            id="paint0_linear_246_4301"
                            x1="16"
                            y1="4"
                            x2="16"
                            y2="28"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="white" />
                            <stop offset="1" stopColor="white" stopOpacity="0" />
                        </linearGradient>

                        <clipPath id="clip0_246_4301">
                            <rect x="4" y="4" width="24" height="24" rx="12" fill="white" />
                        </clipPath>
                    </defs>
                </svg>

                <div className="mr-[1.6937vmin] flex flex-col">
                    <span className="text-[1.5878vmin] font-normal text-[#002033]">{'na'}</span>

                    <span className="text-[1.0159vmin] text-[#00203399]">{'na'}</span>
                </div>

                <div onClick={() => logout()} className="pr-[1.6937vmin] cursor-pointer">
                    <LogoutIcon size="1.5878vmin" />
                </div>
            </div>
        </div>
    );
};
